import React, {Component} from 'react';
import Drawer from '@material-ui/core/Drawer';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from "@material-ui/core/Typography/Typography";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import {withStyles} from "@material-ui/core";

import axios from "axios";
import Cookies from "universal-cookie";
import {inject, observer} from "mobx-react";

import './PolicyDrawer.scss';
import {FETCH_URL} from "../../constants/ServerLinks";

const styles = () => ({
    linearColorPrimary: {
        backgroundColor: 'rgba(35, 45, 75, 0.2)',
        height: 12,
    },
    linearBarColorPrimary: {
        backgroundColor: '#232d4b',
        height: 12,
    },
    linearColorSecondary: {
        backgroundColor: 'rgba(229, 114, 0, 0.2)',
        height: 12,
    },
    linearBarColorSecondary: {
        backgroundColor: '#e57200',
        height: 12,
    },
});

@observer
class PolicyDrawer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            queues: {},
            submissions: {},
            lastUpdated: 0,
            isUpdated: false,
        };

        this.fetchURL = FETCH_URL;
        this.cookies = new Cookies();
        this.countryId = this.cookies.get('country_id');
        this.countryName = this.cookies.get('country_name');

    }

    toggleDrawer = () => {
        this.setState({
            isOpen: !this.state.isOpen,
            isUpdated: false,
        });
    };

    fetchQueuesAndSubmissions = () => {

        axios.all([
            axios.get(this.fetchURL + '/api/v1/policies/queue/', {
                params: {
                    country_id: this.countryId,
                    timestamp: this.state.lastUpdated,
                }
            }),
            axios.get(this.fetchURL + '/api/v1/policies/submissions/', {
                params: {
                    country_id: this.countryId,
                    timestamp: this.state.lastUpdated,
                }
            })
        ])
            .then(axios.spread((qResponse, submissionResponse) => {

                // console.group("PolicyDrawer:fetchQueuesAndSubmissions");
                // console.log(qResponse.data.data);
                // console.log(submissionResponse.data.data);

                if (qResponse.data.success && submissionResponse.data.success) {
                    let queues = qResponse.data.data;
                    let submissions = submissionResponse.data.data[0];

                    if (this.state.lastUpdated < queues.timestamp) {
                        // console.log("Queues/Submission updated");
                        this.setState({
                            queues: queues.queue,
                            submissions: submissions,
                            lastUpdated: queues.timestamp,
                            isUpdated: true
                        });
                    }
                }
                // console.groupEnd();
            }))
            .catch((error) => {
                console.log(error);
            });
    };

    componentDidMount = () => {
        // Fetch the policy queues and submissions
        this.fetchQueuesAndSubmissions();
    };

    shouldComponentUpdate = (nextProps) => {

        if (nextProps.updateDrawer === true) {
            this.fetchQueuesAndSubmissions();
        }
        return true;
    };


    render() {

        const {policies, classes, sendToDecisions} = this.props;
        const polQ = this.state.queues;
        const polS = this.state.submissions;
        const refYear = Object.keys(polQ).sort()[Object.keys(polQ).length - 1];

        const polSlen = Object.keys(polS).length;

        const categories = [...new Set(policies.policies.map(pol => pol.category))];
        // console.log("policies: " + policies)
        // console.log("categories: " + categories)

        return (

            <div>
                <button className={`button btn-open-drawer policy-drawer-pos ${this.state.isUpdated && 'notify'}`}
                        onClick={this.toggleDrawer}>
                    Policy Drawer <span className="notification-dot">{this.state.isUpdated && '* New *'}</span>
                </button>


                <Drawer
                    anchor="bottom"
                    open={this.state.isOpen}
                    onClose={this.toggleDrawer}>
                    <div
                        className="drawerContent"
                        tabIndex={0}
                        role="button"
                        onKeyDown={this.toggleDrawer}
                    >
                        <h3>Policy Drawer&nbsp;&nbsp;&nbsp;
                            {/*<button*/}
                                {/*className="button policyBtn"*/}
                                {/*onClick={sendToDecisions}*/}
                            {/*>*/}
                                {/*Sync with Policy Screen*/}
                            {/*</button>*/}
                        </h3>
                        <div className="close-drawer" onClick={this.toggleDrawer}/>
                        <hr/>
                        {(Array.isArray(Object.values(polS)[0]) && Object.values(polS)[0].length) ||
                        (Array.isArray(Object.values(polQ)[0]) && Object.values(polQ)[0].length) ?
                            <div className="container drawerContent__container">
                                {
                                    categories.filter(item  => item !== "ATGD").map((cat, index) => {{
                                        const policyList = policies.policies.filter(pol => pol.category === cat && pol.country_name === this.countryName);
                                        return (
                                            <ExpansionPanel key={`drawerCat-${index}`} defaultExpanded={true}>
                                                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon/>}>
                                                    <Typography variant={"display1"}>
                                                        <strong>{cat}</strong>
                                                    </Typography>
                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails>

                                                    <table className="polTable">
                                                        <thead>
                                                        <tr>
                                                            <th className="polName">Policies</th>
                                                            {Object.keys(polS).map((year, yIndex) => (
                                                                <th key={`drawer-${year}`}
                                                                    className={yIndex === polSlen - 1 && 'currYear'}>
                                                                    {year}</th>
                                                            ))}
                                                            {/*{!cat.includes("ATG") &&*/}
                                                            {/*<th className={"proposed"}>Proposals</th>}*/}
                                                            {/*<th>&nbsp;</th>*/}
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {policyList.map(pol => {
                                                            const policy = this.props.policies.policies.find(p => p.id === pol.id);
                                                            let currPol = {};
                                                            return (<tr key={`policyDrawer-${policy.id}`}>
                                                                <td>{pol.name}</td>
                                                                {Object.keys(polS).map((year, pIndex) => {
                                                                    const p = polS[year].find(item => item[0] === policy.id);
                                                                    if (pIndex === polSlen - 1) {
                                                                        currPol = p;
                                                                    }
                                                                    let dist = null
                                                                    // const dist = p[2] && 'R: ' + (parseFloat(p[2][0]) * 100) + '% S:' + (parseFloat(p[2][1]) * 100) + '% H:' + (parseFloat(p[2][2]) * 100) + '%';
                                                                    {p ? dist = p[2] && 'R: ' + (parseFloat(p[2][0]) * 100).toFixed(0) + '% S:' + (parseFloat(p[2][1]) * 100).toFixed(0) + '% H:' + (parseFloat(p[2][2]) * 100).toFixed(0) + '%': dist = null}
                                                                    return (
                                                                        <td key={`pd-year-${year}`}>
                                                                            {dist ? dist : p ? policy.values[p[1]] : null}
                                                                        </td>
                                                                    )
                                                                })}
                                                                {/*{!cat.includes("ATG") &&*/}
                                                                {/*<td>{policy.values[polQ[refYear][policy.id]]}</td>}*/}
                                                                {/*<td className={"polIntensity"}>*/}
                                                                    {/*{Object.keys(policy.values).length >= 2 &&*/}
                                                                    {/*<div>*/}
                                                                        {/*<LinearProgress variant="determinate"*/}
                                                                                        {/*classes={{*/}
                                                                                            {/*colorPrimary: classes.linearColorPrimary,*/}
                                                                                            {/*barColorPrimary: classes.linearBarColorPrimary,*/}
                                                                                        {/*}}*/}
                                                                                        {/*value={parseFloat((parseInt(currPol[1]) - 1) / (Object.keys(policy.values).length - 1)) * 100}/>*/}
                                                                        {/*{!cat.includes("ATG")*/}
                                                                        {/*&& <LinearProgress variant="determinate"*/}
                                                                                           {/*classes={{*/}
                                                                                               {/*colorPrimary: classes.linearColorSecondary,*/}
                                                                                               {/*barColorPrimary: classes.linearBarColorSecondary,*/}
                                                                                           {/*}}*/}
                                                                                           {/*value={polQ[refYear][policy.id] ? (parseFloat(parseInt(polQ[refYear][policy.id]) - 1) / (Object.keys(policy.values).length - 1)) * 100 : 0}/>*/}
                                                                        {/*}*/}
                                                                    {/*</div>*/}

                                                                    {/*}*/}
                                                                {/*</td>*/}
                                                            </tr>)
                                                        })}
                                                        </tbody>
                                                    </table>

                                                </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        )
                                    }})
                                }
                            </div>
                            :
                            <h4>No Policies.</h4>
                        }
                    </div>
                </Drawer>
            </div>
        )
    }
}

export default withStyles(styles)(inject('policies')(PolicyDrawer));
